<script setup lang="ts">
import { SwitchRoot, SwitchThumb } from 'reka-ui';

interface Props {
  disabled?: boolean;
  ariaLabel?: string;
}

withDefaults(defineProps<Props>(), {
  disabled: false,
  ariaLabel: undefined,
});

const checked = defineModel<boolean>({ default: false });
</script>

<template>
  <SwitchRoot
    v-model="checked"
    :disabled="disabled"
    :aria-label="ariaLabel"
    class="relative inline-flex h-7 w-12 shrink-0 cursor-pointer items-center rounded-full bg-input outline-none transition-colors focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-secondary"
  >
    <SwitchThumb class="pointer-events-none block size-5 translate-x-1 rounded-full bg-white shadow-sm transition-transform data-[state=checked]:translate-x-6" />
  </SwitchRoot>
</template>
